"use client";

import { Switch } from "@/components/ui/switch";
import { useTranslations } from "next-intl";
import { Dispatch, SetStateAction } from "react";
import { Select } from "../../form";

const Label = ({ title }: { title: string }) => (
  <span className="text-primary text-sm font-medium sm:text-base">
    {title}
  </span>
);

interface AddOptionsProps {
  additionalLivingSpaceCalculation: boolean;
  setAdditionalLivingSpaceCalculation: Dispatch<SetStateAction<boolean>>;
  cutNeeded: boolean;
  setCutNeeded: Dispatch<SetStateAction<boolean>>;
  extraViews: string;
  setExtraViews: Dispatch<SetStateAction<string>>;
  matterport: string;
  setMatterport: Dispatch<SetStateAction<string>>;
  dwgFile: boolean;
  setDwgFile: Dispatch<SetStateAction<boolean>>;
}

const AddOptions = ({ ...props }: AddOptionsProps) => {
  const t = useTranslations("measurementService.priceCalculation");
  const tC = useTranslations("common");

  return (
    <div className="m-auto flex max-w-2xl flex-col gap-5">
      <div className="flex flex-col items-start justify-between gap-2 sm:flex-row sm:items-center">
        <Label title={t("extraCalc")} />
        <Switch
          checked={props.additionalLivingSpaceCalculation}
          onCheckedChange={props.setAdditionalLivingSpaceCalculation}
        />
      </div>
      <div className="flex flex-col items-start justify-between gap-2 sm:flex-row sm:items-center">
        <Label title={t("cutNeeded")} />
        <Switch
          checked={props.cutNeeded}
          onCheckedChange={props.setCutNeeded}
        />
      </div>
      <div className="flex flex-col items-start justify-between gap-2 sm:flex-row sm:items-center">
        <Label title={tC("dwgFile")} />
        <Switch checked={props.dwgFile} onCheckedChange={props.setDwgFile} />
      </div>
      <div className="flex flex-col items-start justify-between gap-2 sm:flex-row sm:items-center">
        <Label title={t("extraViews")} />
        <div className="max-sm:w-full sm:min-w-[180px]">
          <Select
            selectItem={
              [
                { label: tC("no"), value: "no" },
                { label: t("oneView"), value: "oneView" },
                { label: t("twoViews"), value: "twoViews" },
                { label: t("threeViews"), value: "threeViews" },
                { label: t("fourViews"), value: "fourViews" },
              ] as const
            }
            value={props.extraViews || "no"}
            onValueChange={(newValue: string) => {
              props.setExtraViews(newValue);
            }}
          />
        </div>
      </div>
      <div className="flex flex-col items-start justify-between gap-2 sm:flex-row sm:items-center">
        <Label title={t("matterport")} />
        <div className="max-sm:w-full sm:min-w-[180px]">
          <Select
            defaultValue="no"
            selectItem={
              [
                { label: tC("no"), value: "no" },
                { label: t("forThreeMonth"), value: "forThreeMonth" },
                { label: t("forSixMonth"), value: "forSixMonth" },
              ] as const
            }
            value={props.matterport || "no"}
            onValueChange={(newValue: string) => {
              props.setMatterport(newValue);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default AddOptions;
